// components/protectedRoute.jsx
import { useContext } from "react";
import { AuthContext } from "../common/constants";
import { Navigate } from "react-router-dom";
import AccessDenied from "./accessDenied";

// Rôles ayant accès complet
const FULL_ACCESS_ROLES = ['superAdmin', 'directeur'];

const ProtectedRoute = ({ perm, anyOf, children }) => {
  const { initialized, isAuthenticated, currentUser } = useContext(AuthContext);

  if (!initialized) return null; // ou spinner
  if (!isAuthenticated) return <Navigate to="/" replace />;

  // pas de permission => accès connecté simple
  if (!perm && !anyOf) return children;

  // Rôles avec accès complet
  if (FULL_ACCESS_ROLES.includes(currentUser?.role)) {
    return children;
  }

  const perms = new Set(currentUser?.permissions || []);

  // Vérifier les permissions anyOf (au moins une)
  if (anyOf && anyOf.length > 0) {
    const hasAnyPerm = anyOf.some(p => perms.has(p));
    if (!hasAnyPerm) {
      return <AccessDenied requiredPerm={anyOf.join(' ou ')} />;
    }
  }

  // Vérifier la permission unique
  if (perm && !perms.has(perm)) {
    return <AccessDenied requiredPerm={perm} />;
  }

  return children;
};

export default ProtectedRoute;
